var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignedPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 98,
    viewBox: "0 0 82 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.9751 25H56.9751V1L80.9751 25Z",
    fill: "#212B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9749 25V89.05C80.9749 93.4 77.3749 97 73.0249 97H71.0749H8.9749C4.6249 97 1.0249 93.4 1.0249 89.05V11.05V8.95C1.0249 4.6 4.6249 1 8.9749 1H56.9749",
    stroke: "#212B33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9751 1V25H80.9751L56.9751 1Z",
    stroke: "#212B33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2749 31.8999H38.2249",
    stroke: "#212B33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2749 46.4502H58.1749",
    stroke: "#212B33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2749 61H58.1749",
    stroke: "#212B33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9751 84.55C44.5251 80.05 47.9751 74.8 49.9251 75.4C52.1751 76.15 50.6751 85.6 51.8751 85.9C53.2251 86.05 56.0751 77.35 58.3251 77.35C60.4251 77.35 59.2251 87.7 61.4751 88C62.9751 88 65.2251 84.25 68.9751 70.75",
    stroke: "#212B33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedPdf);
export default __webpack_public_path__ + "static/media/SignedPDF.86eb8fc0dc2fc938de9fdd83f51c8419.svg";
export { ForwardRef as ReactComponent };